export const formatString = (str) => {
    return str.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
}

export function getMediaType(filename) {
  const extension = filename.split('.').pop().toLowerCase();

  switch (extension) {
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return 'image';
    case 'mp4':
      return 'video';
    default:
      return 'unknown'; // Or you could return null, an empty string, or throw an error
  }
}